import { createContext, useContext } from 'react';

export type DisplayMode = 'dark' | 'light';
export type UiTheme = 'default' | 'shoelace' | 'awesome';

export const DISPLAY_MODE_KEY = 'display_mode';
export const UI_THEME_KEY = 'ui_theme';

export const applyUiTheme = (theme: UiTheme) => {
  const classList = document.documentElement.classList;
  classList.remove(
    'wa-theme-awesome',
    'wa-palette-bright',
    'wa-theme-shoelace',
    'wa-palette-shoelace',
    'wa-brand-blue',
  );
  if (theme === 'awesome') {
    classList.add('wa-theme-awesome', 'wa-palette-bright');
  } else if (theme === 'shoelace') {
    classList.add('wa-theme-shoelace', 'wa-palette-shoelace', 'wa-brand-blue');
  }
  // 'default' needs no classes — the :root selector in default.css covers it
};

export const applyDisplayMode = (mode: DisplayMode) => {
  document.documentElement.classList.toggle('wa-dark', mode === 'dark');
  document.documentElement.classList.toggle('wa-light', mode === 'light');
};

export type PrefsContextValue = {
  theme: UiTheme;
  mode: DisplayMode;
  setTheme: (theme: UiTheme) => void;
  setMode: (mode: DisplayMode) => void;
};

export const PrefsContext = createContext<PrefsContextValue>({
  theme: 'default',
  mode: 'light',
  setTheme: () => {},
  setMode: () => {},
});

const usePrefs = () => useContext(PrefsContext);

export default usePrefs;
